import { Autocomplete, Box, Dialog, DialogContent, FormControl, Grid, Icon, IconButton, InputAdornment, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Theme, Typography, useTheme } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import BreadCrum from '../../lib/BreadCrum'
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { USER_ROLES } from '../../utils/constant';
import { isRMLikeRole, maskInfo } from '../../utils/utilityFunctions';
import BankCard, { BankCardSkeleton } from './BankCard';
// import { BluePlusIcon, whitePlusIconOutlined, BluePlusIconOutlined, DialogCloseIcon, InfoIconSubtitle, SearchIcon, YellowWarning } from '../../assets/SvgIcons';
import { BluePlusIcon, whitePlusIconOutlined as WhitePlusIconOutlined, BluePlusIconOutlined, DialogCloseIcon, InfoIconSubtitle, SearchIcon, YellowWarning } from '../../assets/SvgIcons';
import { getReportsInvestorList } from '../../redux-store/actions/reports';
import { RootStateType } from '../../redux-store/reducers';
import { ReportsListRes } from '../../redux-store/types/api-types';
import { DropdownLoading } from '../analytics/loadingComponents';
import AddBankForm from './AddBankForm';
import { BankListObj, BanksListRes, bseGenerateOtp, bseGenOtpRes, fetchBanksList, InvestorList, InvestorListBanksRes, investorListForBanks } from '../../redux-store/actions/bank';
import { SubHeading } from '../investors/components';
import { showError } from '../../redux-store/actions/auth';

export default function UpdateBank(): JSX.Element {
    const theme = useTheme();
    const history = useHistory();
    const dispatch = useDispatch();
    const initialRouter = history.location.pathname?.split('/').filter((item) => item !== '')
    const { role = "" } = useSelector((state: any) => state.auth);
    const { iwappRmId = "" } = useSelector((state: RootStateType) => state.id);
    const [investorListLoading, setInvestorListLoading] = useState<boolean>(false);
    const [investorList, setInvestorList] = useState<InvestorListBanksRes>({} as InvestorListBanksRes);
    const [selectedInvestor, setSelectedInvestor] = useState<string>("");
    const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false)
    const [banksList, setBanksList] = useState<Array<BankListObj>>([]);
    const [editDialogOpen, setEditDialogOpen] = useState<boolean>(false);
    const [banksListLoading, setBanksListLoading] = useState<boolean>(false);
    const [selectedBank, setSelectedBank] = useState<BankListObj>({} as BankListObj);
    const [curBankIndex, setCurBankIndex] = useState<number>(0);
    const [selectedInvObj, setSelectedInvestorObj] = useState<InvestorList>({} as InvestorList);
    const { applicationId: investorApplicationId = "", clientInterfaceCode = "" } = useSelector((state: RootStateType) => state.id);
    const [otpLoading, setOtpLoading] = useState<{ deleteBank: boolean, bankId: string | number }>({ deleteBank: false, bankId: "" });
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio);

    const investorListOptions = useMemo(() => investorList?.result?.map(obj => ({
        label: obj?.customerName ?? "",
        value: obj?.clientCode ?? ""
    })) ?? [], [investorList]);

    useEffect(() => {
        isRMLikeRole(role) && fetchInvestorList();
        role === USER_ROLES.INVESTOR && handleInvestorChange();
    }, [])

    const fetchInvestorList = async () => {
        try {
            setInvestorListLoading(true);
            const payload = {
                rmId: `${iwappRmId}`
            }
            const response = await (dispatch(investorListForBanks(payload)) as unknown as Promise<InvestorListBanksRes>);
            setInvestorList(response);
        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setInvestorListLoading(false);
        }
    };
    // const handleInvestorChange = async (event?: SelectChangeEvent) => {
    //     console.log('abcd', event);
    //     let banksListPayload = {};
    //     const selectedInvestor = investorList?.result?.find((item: InvestorList) => item?.clientCode === event?.target?.value) as InvestorList;
    //     if (isRMLikeRole(role)) {
    //         setSelectedInvestor(event?.target?.value ?? "");
    //         setSelectedInvestorObj(selectedInvestor);
    //         const applicationId = selectedInvestor?.applicationId ?? 0;
    //         banksListPayload = {
    //             applicationId: applicationId,
    //             isActive: true
    //         }
    //     }
    //     else {
    //         banksListPayload = {
    //             applicationId: investorApplicationId,
    //             isActive: true
    //         }
    //     }
    //     try {
    //         setBanksListLoading(true);
    //         const listOfBanks = await (dispatch(fetchBanksList(banksListPayload)) as unknown as Promise<BanksListRes>);
    //         setBanksList(listOfBanks?.result ?? []);
    //     } catch (e) {
    //         console.log('ERROR!', e)
    //     } finally {
    //         setBanksListLoading(false);
    //     }
    // };

    const handleInvestorChange = async (selectedObj?: ({ label: string; value: string; } | null)) => {
        if (isRMLikeRole(role) && !selectedObj) {
            setSelectedInvestor("")
            setSelectedInvestorObj({} as InvestorList)
            return;

        }
        let banksListPayload = {};
        const selectedInvestor = investorList?.result?.find(
            (item: InvestorList) => item?.clientCode === selectedObj?.value
        ) as InvestorList;

        if (isRMLikeRole(role)) {
            setSelectedInvestor(selectedObj?.value ?? '');
            setSelectedInvestorObj(selectedInvestor);
            const applicationId = selectedInvestor?.applicationId ?? 0;
            banksListPayload = {
                applicationId: applicationId,
                isActive: true
            };
        } else {
            banksListPayload = {
                applicationId: investorApplicationId,
                isActive: true
            };
        }

        try {
            setBanksListLoading(true);
            const listOfBanks = await (dispatch(fetchBanksList(banksListPayload)) as unknown as Promise<BanksListRes>);
            setBanksList(listOfBanks?.result ?? []);
        } catch (e) {
            console.log('ERROR!', e);
        } finally {
            setBanksListLoading(false);
        }
    };

    const handleNoInvestorDialogClose = () => {
        setNoInvestorDialogVisible(false)
    }

    const handleEditDialogClose = () => {
        setEditDialogOpen(false)
    }

    const handleEditBank = (bank: BankListObj, index: number) => {
        setEditDialogOpen(true)
        setSelectedBank(bank)
        setCurBankIndex(index);
    }

    const deleteBank = async (bank: BankListObj) => {
        if (bank?.defaultBankAccount) {
            dispatch(showError('Please set another bank as default to delete this one'));
            return;
        }
        const updatedBanks = banksList?.map((item: BankListObj) => item?.id === bank?.id ? { ...item, isDeleted: "1", isModified: "1" } : item);
        try {
            setOtpLoading({ deleteBank: true, bankId: bank?.id });
            const genOtpRes = (await dispatch(bseGenerateOtp({
                banksList: updatedBanks,
                clientCode: (selectedInvObj?.clientCode || clientInterfaceCode) ?? "",
                document: {}
            }))) as unknown as bseGenOtpRes;

            if (!genOtpRes?.isSuccess) return;
            if (genOtpRes?.isSuccess) {
                history.push('/bank/otp-screen', {
                    id: genOtpRes?.id ?? "",
                    cartId: genOtpRes?.cartId ?? "",
                    message: genOtpRes?.message ?? "",
                });
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            setOtpLoading({ deleteBank: false, bankId: "" });
        }
    }

    const rmRouterPath =
        [
            {
                name: 'Dashboard',
                path: '/dashboard',
                warning: false
            },
            {
                name: 'Update Bank',
                path: `/${initialRouter[0]}`,
            },
        ]

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
        },
        {
            name: 'Update Bank',
            path: `/${initialRouter[0]}`,
        },

    ]
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />
            </Box>
            <Box mb="25px" mt={2}>
                <Typography variant='h1' color="text.primary">
                    Update Bank
                </Typography>
            </Box>
            <Box
                sx={{
                    p: { xs: "15px", sm: "25px" },
                    bgcolor: "background.paper",
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                    borderRadius: '25px',
                    minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
                }}>
                {isRMLikeRole(role) && (
                    <Box sx={{ width: { xs: "100%", sm: '80%', lg: "50%", xl: '40%' }, marginTop: { xs: "10px", sm: "30px" } }}>
                        {investorListLoading && (<DropdownLoading />)}

                        {/* {!investorListLoading && (
                            <FormControl fullWidth>
                                <InputLabel id="investor-select">Select Investor*</InputLabel>
                                <Select
                                    labelId="investor-select"
                                    value={selectedInvestor}
                                    label="Select Investor*"
                                    onChange={handleInvestorChange}
                                    sx={{ borderRadius: '8px' }}
                                >
                                    {investorListOptions?.map(obj => (
                                        <MenuItem
                                            key={obj.label}
                                            value={obj.value}
                                        >
                                            {maskInfo(obj?.label ?? "")}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl> */}
                        {/* {!investorListLoading &&
                            (<Autocomplete
                                value={{ label: selectedInvestor, value: selectedInvestor }}
                                onChange={(event, value, reason, details) => handleInvestorChange(event as SelectChangeEvent)}
                                options={investorListOptions}
                                disabled={false}
                                sx={{
                                    width: '100%',
                                    borderRadius: '50px'
                                }}
                                renderInput={(params) =>
                                    <TextField {...params} label=""
                                        placeholder="Search Investor...."
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>),
                                            disableUnderline: true,
                                            sx: {
                                                borderRadius: '8px',
                                                backgroundColor: 'white',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '8px',
                                                },
                                            },
                                        }}
                                    />
                                }
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option?.label ?? ""}
                                    </li>
                                )}
                            />
                            )} */}

                        {!investorListLoading && (
                            <Autocomplete
                                value={investorListOptions?.find((item) => item?.value === selectedInvestor) ?? null}
                                onChange={(event, newValue) => {
                                    handleInvestorChange(newValue);
                                }}
                                options={investorListOptions}
                                noOptionsText="No investors found"
                                sx={{
                                    width: '100%',
                                    borderRadius: '50px'
                                }}
                                getOptionLabel={(option) => `${option?.label}(${option?.value})`}
                                getOptionKey={(option) => option?.value}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Search Investor..."
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                            disableUnderline: true,
                                            sx: {
                                                borderRadius: '8px',
                                                backgroundColor: theme.palette.common.white,
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '8px',
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />
                        )}
                    </Box>
                )}
                {isRMLikeRole(role) && !investorListLoading && !(selectedInvestor) && (
                    <Box mb={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 'calc(100vh - 495px)' }}>
                        <Typography variant='body_600' color="text.primary">
                            Select the Investor to View Banks
                        </Typography>
                    </Box>
                )}
                {(isRMLikeRole(role) && selectedInvestor || role === USER_ROLES.INVESTOR) && (
                    <>
                        <Box
                            sx={{
                                mt: { xs: '5px', sm: '20px' },
                                p: { xs: "10px", sm: "35px" },
                                bgcolor: "background.paper",
                                boxShadow: `0px 4px 5px 0px ${theme.palette.common.black}0D`,
                                borderRadius: { xs: '3px', sm: '15px' },
                                border: `1px solid ${theme.palette.grey[100]}`,
                            }}>
                            <Box
                                mb={{ xs: 2, sm: 5 }}
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: { xs: '2px' }
                                }}
                            >
                                <Typography variant='h2' color="text.primary">
                                    {role === USER_ROLES.INVESTOR ? "Your Banks" : "Selected Investors Banks"}
                                </Typography>
                                <Box sx={{ display: 'flex', columnGap: '5px' }}>
                                    <Box
                                        sx={{
                                            color: 'common.white',
                                            backgroundColor: 'customColors.subtitle',
                                            padding: { xs: '6px 8px', sm: '6px 8px' },
                                            display: 'flex',
                                            alignItems: 'flex-start ',
                                            gap: '6px',
                                            borderRadius: '8px',
                                            maxWidth: '450px',
                                            ...theme.typography.overline_400,
                                        }}>
                                        <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'flex-start' }}>
                                            <InfoIconSubtitle />
                                        </Box>
                                        A Maximum of 5 banks can be Added. Please ensure that the BSE Authentication is completed after Adding/Modifying the Bank Details to ensure smooth Transactions.
                                    </Box>
                                </Box >
                            </Box >
                            {/* banks listing */}

                            < Grid container spacing={2} >
                                {
                                    banksListLoading ? (
                                        Array.from({ length: 3 }).map((_, index) => (
                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                <BankCardSkeleton />
                                            </Grid>
                                        ))
                                    ) : (
                                        <>
                                            {banksList?.length === 0 && (
                                                <Grid item xs={12} justifyContent={'center'} alignItems={'center'}>
                                                    <Typography variant='body_600' color="text.primary" textAlign={'center'}>
                                                        No Banks Found
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {banksList?.length > 0 &&
                                                banksList.map((bank: BankListObj, index: number) => (
                                                    <Grid item key={index} xs={12} md={6} lg={4}>
                                                        <BankCard
                                                            isLoading={false}
                                                            bank={bank}
                                                            index={index}
                                                            editDialogOpen={editDialogOpen}
                                                            setEditDialogOpen={setEditDialogOpen}
                                                            handleEditBank={handleEditBank}
                                                            handleDeleteBank={deleteBank}
                                                            otpLoading={otpLoading}
                                                            totalBanks={banksList ?? []}
                                                        />
                                                    </Grid>
                                                ))}
                                        </>
                                    )
                                }
                            </Grid >


                        </Box >
                        {
                            banksList?.length < 5 &&
                            (<Box sx={{ padding: '10px', mt: '20px', borderRadius: "10px", border: `1px solid ${theme.palette.primary[500]}`, background: theme.palette.primary[500], textAlign: 'center', width: { xs: "200px", sm: "auto" }, mx: { xs: "auto", sm: "0" } }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', columnGap: '5px', cursor: 'pointer' }}
                                    onClick={() => history.push(`/bank/addBank`, {
                                        banksList: banksList ?? [],
                                        selectedInvObj: selectedInvObj ?? {}
                                    })}
                                >
                                    <IconButton aria-label="Add new bank">
                                        <WhitePlusIconOutlined />
                                    </IconButton>
                                    <Typography variant='body_500' sx={(theme: Theme) => ({
                                        color: theme.palette.primary[100]
                                    })}>
                                        Add New Bank
                                    </Typography>
                                </Box>
                            </Box>
                            )
                        }
                    </>
                )}
            </Box >
            <Dialog
                onClose={handleNoInvestorDialogClose}
                open={isNoInvestorDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "22px 24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "12px",
                                alignItems: "center"
                            }}
                        >
                            <YellowWarning />
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                            >
                                No Investor Found!!
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleNoInvestorDialogClose}
                            sx={{
                                padding: "5px"
                            }}
                        >
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Dialog>
            <Dialog
                open={editDialogOpen}
                onClose={handleEditDialogClose}
                maxWidth='lg'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '25px',
                        backgroundColor: theme.palette.common.white,
                        padding: { xs: "10px", sm: "20px" },
                        width: "1063px",
                        maxHeight: "80%",
                        [theme.breakpoints.down('sm')]: {
                            margin: { xs: '3px' }
                        },
                    },
                })}
            >
                <DialogContent
                    sx={{
                        maxHeight: "100%",
                        overflowY: "auto",
                        [theme.breakpoints.down('sm')]: {
                            padding: '10px',
                        }
                    }}
                >
                    <Box sx={{ mb: 2, borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`, padding: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                        <Typography variant='body_600' mb={1}>
                            {`Edit Bank ${curBankIndex + 1} Details`}
                        </Typography>
                        <IconButton aria-label="Close edit dialog" onClick={handleEditDialogClose}>
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                    <AddBankForm editBank={selectedBank} isComingFromEdit banksList={banksList ?? []} selectedInvestor={selectedInvObj} />
                </DialogContent>
            </Dialog>
        </>
    )
}

